import { render, staticRenderFns } from "./QRkod.vue?vue&type=template&id=49689578&scoped=true&"
import script from "./QRkod.vue?vue&type=script&lang=js&"
export * from "./QRkod.vue?vue&type=script&lang=js&"
import style0 from "./QRkod.vue?vue&type=style&index=0&id=49689578&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49689578",
  null
  
)

export default component.exports